<template>
  <div class="g-h100">
    <van-tabs :sticky="true">
      <van-tab :title="item.name" v-for="item in tabs" :key="item.id" v-model="active">
        <div class="inner">
          <div class="g-h100 g-flex-vh-center" v-if="listObj[item.id].length == 0">
            <van-empty
              description="暂无记录～"
              image="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/tips/empty.png"
              image-size="128"
            />
          </div>

          <van-cell v-for="i in listObj[item.id]" :key="i.id">
            <div class="ph6">
              <div class="g-flex-v-center fs16">
                <span v-if="i.taskType === 15">
                  <van-popover
                    v-model="pop1"
                    class="popover-wrap"
                    theme="dark"
                    trigger="click"
                    placement="top-start"
                    :offset="[0, 4]"
                  >
                    {{`每${-i.scoreRule.score}积分，可抵扣学费${i.scoreRule.promotionMoney}元`}}
                    <template #reference>
                      {{ i.taskDesc }}
                      <van-icon name="question-o" class="tips-icon" />
                    </template>
                  </van-popover>
                </span>
                <span v-else>{{ i.taskDesc }}</span>
                <div>
                  <span v-if="i.taskType === 8">
                    <span v-for="(item, idx) of i.scoreRule" :key="idx">
                      获得{{ 5 - idx }}星
                      <span class="score">+{{ item.score }}</span>
                      <span v-if="idx !== i.scoreRule.length - 1">,</span>
                    </span>
                  </span>

                  <span class="score" v-else
                    >{{ item.id === 'add' ? '+' : '' }}{{ i.scoreRule.score }}</span
                  >
                </div>
              </div>
            </div>
          </van-cell>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: 0,
      pop1: false,
      tabs: [
        {
          id: 'add',
          name: '加分规则',
        },
        {
          id: 'reduce',
          name: '减分规则',
        },
      ],
      listObj: {
        add: [],
        reduce: [],
      },
    };
  },
  methods: {},
  created() {
    this.$api
      .findMemberPointRuleList({
        ruleType: 1,
      })
      .then(res => {
        this.listObj.add = res.data.map(item => {
          item.scoreRule = JSON.parse(item.scoreRule);
          return item;
        });
      });
    this.$api
      .findMemberPointRuleList({
        ruleType: 2,
      })
      .then(res => {
        this.listObj.reduce = res.data.map(item => {
          item.scoreRule = JSON.parse(item.scoreRule);
          return item;
        });
      });
  },
};
</script>

<style scoped>
.g-flex-v-center {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.g-flex-vh-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.g-h100 {
  height: 100%;
}
.ph6 {
  padding: calc(var(--gap) * 16) 0;
}
.fs16 {
  font-size: var(--fs-lg);
}
.month-total {
  padding: calc(var(--gap) * 10) calc(var(--gap) * 16);
  font-size: var(--fs-md);
  color: var(--g6);
}
.date {
  font-size: var(--fs-sm);
  line-height: var(--lh-sm);
  color: var(--g6);
  margin-top: calc(var(--gap) * 2);
}

.score {
  color: var(--c1);
}
</style>